import { authToken } from '../env'
import axios from '../_client'
import store from '@/store'
import { EventBus } from '@/event-bus'

console.log(store.getters)
const LOCATION_URL = store.getters['permissions/url']
const LOCATION_API_TOKEN = store.getters['permissions/apiToken']

const axiosInstaceV1 = axios.create({
  baseURL: `${LOCATION_URL}`,
  headers: {
    'api-token': LOCATION_API_TOKEN
  }
})
axiosInstaceV1.interceptors.response.use(function (response) {
  if (response.data.redirect_to) {
    location.href = response.data.redirect_to
  }
  return response
}, function (error) {
  if (error.response.status === 401) {
    EventBus.$emit('unauthorized')
  }
  if (error.response.status !== 404) {
    EventBus.$emit('show-error-modal', error)
  }
  return Promise.reject(error)
})
export const LocationGroupAPI = {

  getAllLocationGroups() {
    return axiosInstaceV1({
      method: 'get',
      url: `/groups`,
      params: {
        withLocations: true
      },
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  createLocationGroup(data) {
    return axiosInstaceV1({
      method: 'post',
      url: `/groups`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  updateLocationGroup({ groupId, data }) {
    return axiosInstaceV1({
      method: 'patch',
      url: `/groups/${groupId}`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  addLocationsToGroup({ groupId, data }) {
    return axiosInstaceV1({
      method: 'post',
      url: `/groups/${groupId}/locations`,
      data,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  getLocationGroupById(id, withLocations = false, withInactive = false) {
    return axiosInstaceV1({
      method: 'GET',
      url: `/groups/${id}?withLocations=${withLocations}&inactive=${withInactive}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  addLocationToGroup(groupId, locationId) {
    return axiosInstaceV1({
      method: 'POST',
      url: `/groups/${groupId}/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  removeLocationFromAGroup(groupId, locationId) {
    return axiosInstaceV1({
      method: 'DELETE',
      url: `/groups/${groupId}/locations/${locationId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  },
  deleteLocationGroup(groupId) {
    return axiosInstaceV1({
      method: 'DELETE',
      url: `/groups/${groupId}`,
      headers: {
        'api-token': LOCATION_API_TOKEN,
        'auth-token': authToken()
      }
    })
  }
}
